import { IPublishedConnectionUsageInfo } from '../ServerApi/types/IUsageInfo';
import {
  ICreatedItemInfo,
  IDescriptionItemInfo,
  IExplorableItemTypeInfo,
  IFavoriteItem,
  IIdItemInfo,
  IItemStatisticsInfo,
  INamedItemInfo,
  IOwnedItemInfo,
  IProjectItemInfo,
  ITaggedItemInfo,
  IUpdatedItemInfo,
} from './resourceInfoParts';

export interface IPublishedConnectionBase extends
  IExplorableItemTypeInfo<'publishedConnection'>,
  INamedItemInfo,
  IIdItemInfo,
  IUpdatedItemInfo,
  ICreatedItemInfo,
  IFavoriteItem,
  IDescriptionItemInfo,
  ITaggedItemInfo,
  IOwnedItemInfo,
  IProjectItemInfo
{
  luid: string;
}

export interface IPublishedConnectionInfo extends
  IPublishedConnectionBase,
  IItemStatisticsInfo<IPublishedConnectionUsageInfo>
{
}

export interface IPublishedConnectionDetailInfo extends
  IPublishedConnectionBase
{
  tables: IPublishedConnectionTableInfo[];
}

export interface IPublishedConnectionDetailWithUsageInfo extends
  IPublishedConnectionDetailInfo,
  IItemStatisticsInfo<IPublishedConnectionUsageInfo>
{
}

export interface IPublishedConnectionTableInfo {
  databaseName?: string;
  schemaName?: string;
  tableName: string;
}

export function isPublishedConnectionInfo(publishedConnection: IExplorableItemTypeInfo): publishedConnection is IPublishedConnectionInfo {
  return (publishedConnection.contentType === 'publishedConnection');
}
